module.exports = __webpack_public_path__ + "img/7539b53.jpg";